import styles from "./Footer.module.css";

const Footer = () => {
  return (
    
    <footer className={styles.footer}>
        <h3>Escreva sobre o que você tem interesse!</h3>
        <p>Lucas Silveira &copy; Miniblog 2023</p>
    </footer>

  )
}

export default Footer